import React from "react";
import AnalyticsTypeOfIncomeExpenseItemGenericSkeleton from "./AnalyticsTypeOfIncomeExpenseItemGenericSkeleton";

function AnalyticsTypeOfIncomeExpenseItemDetailSkeleton() {
  return (
    <>
      <AnalyticsTypeOfIncomeExpenseItemGenericSkeleton />
    </>
  );
}

export default AnalyticsTypeOfIncomeExpenseItemDetailSkeleton;
